import { isEmpty } from '@/utils/general/browserHelper'
import React from 'react'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'
import PriceFilter from './priceFilter'

const PriceFilterNew = ({
  oneWayPrice,
  returnOneWayPrice,
  selectedFilters,
  onFilterChange,
  isRT,
  showPerAdultPricing,
  processedData,
  clearFiltersCategoryWise,
  isRevamp = false,
}: any) => {
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, 'oneWayPrice')
  const onwardMinPrice = showPerAdultPricing ? oneWayPrice?.minADT : oneWayPrice?.min
  const onwardMaxPrice = showPerAdultPricing ? oneWayPrice?.maxADT : oneWayPrice?.max
  const onwardCurrentPrice = showPerAdultPricing ? oneWayPrice?.currentADT : oneWayPrice?.current
  const returnMinPrice = showPerAdultPricing ? returnOneWayPrice?.minADT : returnOneWayPrice?.min
  const returnMaxPrice = showPerAdultPricing ? returnOneWayPrice?.maxADT : returnOneWayPrice?.max
  const returnCurrentPrice = showPerAdultPricing ? returnOneWayPrice?.currentADT : returnOneWayPrice?.current
  const showBothLegs = isRT && !isEmpty(returnOneWayPrice)
  const count =
    Number(onwardCurrentPrice < onwardMaxPrice) + Number(!!showBothLegs && returnCurrentPrice < returnMaxPrice)
  const shared = { isPerAdult: showPerAdultPricing, isRT, isRevamp, selectedFilters }

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Flight prices' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(oneWayPrice) && (
          <PriceFilter
            {...shared}
            minPrice={onwardMinPrice}
            maxPrice={onwardMaxPrice}
            currentPrice={onwardCurrentPrice}
            onFilterChange={onFilterChange}
            from={processedData?.source}
            to={processedData?.destination}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />

        {showBothLegs && (
          <PriceFilter
            {...shared}
            minPrice={returnMinPrice}
            maxPrice={returnMaxPrice}
            currentPrice={returnCurrentPrice}
            onFilterChange={(type: any, value: any) => onFilterChange(type, value, 0, 'returnLeg')}
            from={processedData?.destination}
            to={processedData?.source}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default PriceFilterNew
